module.exports = __webpack_public_path__ + "img/regiter-icon03-selected.efe0a0f8.png";